import { forwardRef } from 'react'

import { ButtonProps as BaseButtonProps } from '@mui/material/Button'

import { StyledButton } from './StyledButton'

export type ButtonAnchorProps = {
  target?: string
}

export type ButtonProps = Omit<BaseButtonProps, 'color' | 'disableRipple' | 'variant'> & ButtonAnchorProps & {
  primary?: boolean
  secondary?: boolean
  outline?: boolean
  arrow?: boolean
  text?: boolean
  round?: boolean
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ primary, secondary, outline, arrow, text, round, ...props }, ref) => {
    const buttonProps: BaseButtonProps = props

    if (primary) {
      buttonProps.color = 'primary'
      buttonProps.variant = 'contained'
      buttonProps.disableRipple = true
    } else if (secondary) {
      buttonProps.color = 'secondary'
      buttonProps.variant = 'contained'
      buttonProps.disableRipple = true
    } else if (outline) {
      buttonProps.variant = 'outlined'
    } else if (arrow) {
      buttonProps.variant = 'contained'
      buttonProps.color = 'secondary'
      buttonProps.disableRipple = true
    } else {
      buttonProps.color = 'primary'
      buttonProps.variant = 'text'
      buttonProps.disableRipple = true
    }

    const { children, ...restButtonProps } = buttonProps

    return (
      <StyledButton ref={ref} disableRipple $round={round} $arrow={arrow} {...restButtonProps}>
        {arrow ? <span>{children}</span> : children}
      </StyledButton>
    )
  },
)